var _rect, _rect2, _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMastercardmethod(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 26,
    viewBox: "0 0 37 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.686959,
    y: 0.861764,
    width: 35.0197,
    height: 24.1247,
    rx: 4.28018,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.686959,
    y: 0.861764,
    width: 35.0197,
    height: 24.1247,
    rx: 4.28018,
    stroke: "#F2F4F7",
    strokeWidth: 0.778215
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6867 19.596C26.5725 19.596 29.7225 16.4834 29.7225 12.6439C29.7225 8.8044 26.5725 5.69186 22.6867 5.69186C20.9453 5.69186 19.3516 6.31703 18.123 7.35262C16.8944 6.31703 15.3007 5.69186 13.5592 5.69186C9.67346 5.69186 6.52344 8.8044 6.52344 12.6439C6.52344 16.4834 9.67346 19.596 13.5592 19.596C15.3007 19.596 16.8944 18.9708 18.123 17.9352C19.3516 18.9708 20.9453 19.596 22.6867 19.596Z",
    fill: "#ED0006"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.123 17.9352C19.6358 16.6601 20.5951 14.7627 20.5951 12.6439C20.5951 10.5251 19.6358 8.62774 18.123 7.35261C19.3516 6.31702 20.9453 5.69186 22.6868 5.69186C26.5725 5.69186 29.7226 8.8044 29.7226 12.6439C29.7226 16.4834 26.5725 19.596 22.6868 19.596C20.9453 19.596 19.3516 18.9708 18.123 17.9352Z",
    fill: "#F9A000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1229 17.9352C19.6357 16.6601 20.5949 14.7627 20.5949 12.6439C20.5949 10.5252 19.6357 8.62778 18.1229 7.35264C16.6101 8.62778 15.6509 10.5252 15.6509 12.6439C15.6509 14.7627 16.6101 16.6601 18.1229 17.9352Z",
    fill: "#FF5E00"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercardmethod);
export default __webpack_public_path__ + "static/media/Mastercard method.6bf577e55449f8d357d1ec5ffd461908.svg";
export { ForwardRef as ReactComponent };